import getApiClient from 'src/utils/getApiClient'
import type { OtherCategoryItem } from 'src/components/pages/[town-translit]/diagnostika/analiz/api/apiOtherCategories.types'

const apiClient = getApiClient()

const apiOtherCategories = {
  get(townTranslit: string) {
    return apiClient
      .get<OtherCategoryItem[]>('/ajax/diagnostika/services/category/other/', {
        params: {
          town_translit: townTranslit,
        },
      })
      .then(response => response.data)
  },
}

export default apiOtherCategories
